import { SWRConfig } from 'swr';
import { swrConfig } from '@/lib/swr-config';
import type { ReactNode } from 'react';

interface SWRProviderProps {
  children: ReactNode;
  fallback?: Record<string, unknown>;
}

export default function SWRProvider({ children, fallback = {} }: SWRProviderProps) {
  return (
    <SWRConfig value={{ ...swrConfig, fallback }}>
      {children}
    </SWRConfig>
  );
}
